/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Input, FormFeedback, Tooltip } from "reactstrap";

const FileUploadInput = ({
  label = "Upload File",
  id = "fileUploadInput",
  name = "file",
  required = false,
  acceptedTypes = [],
  maxSize = Infinity,
  multiple = false, // Allow multiple files by default false
  customErrorMessages = {
    required: "This field is required.",
    type: "Only the allowed file types are accepted.",
    size: `File size must be less than ${maxSize / (1024 * 1024)}MB.`,
  },
  showHelp = false,
  helpText = "Please upload a valid file.",
  onFileUpload = () => {},
  layout = "below",
}) => {
  const [error, setError] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const validateInput = (files) => {
    setError(""); // Reset error message
    if (required && files.length === 0) {
      return customErrorMessages.required || "This field is required.";
    }

    const filesArray = Array.from(files);

    for (let file of filesArray) {
      if (acceptedTypes.length > 0 && !acceptedTypes.includes(file.type)) {
        return customErrorMessages.type || `Only allowed file types are: ${acceptedTypes.join(", ")}`;
      }
      if (file.size > maxSize) {
        return customErrorMessages.size || `File size must be less than ${maxSize / (1024 * 1024)}MB.`;
      }
    }
    return ""; // No errors
  };

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;

    // Validate input and capture any error messages
    const errorMessage = validateInput(selectedFiles);
    if (errorMessage) {
      setError(errorMessage);
      return;
    }

    // If validation passes, call the onFileUpload handler
    if (onFileUpload) {
      onFileUpload(multiple ? Array.from(selectedFiles) : selectedFiles[0]); // Handle single/multiple
    }
  };

  return (
    <div className={layout === "inline" ? "d-flex align-items-center mb-2" : "mb-2"}>
      <label htmlFor={id} className="d-flex" style={{ width: layout === "inline" ? "25%" : "100%" }}>
        {label} {required && <span className="text-danger">*</span>}
        {showHelp && (
                    <span id={`helpTooltip-${id}`} className="ms-1" style={{ position: "relative", top: "-3px" }}>
                    <i className="ri-question-line" style={{ cursor: 'pointer', fontSize: '16px' }}></i>
                  </span>
                  
                )}
      </label>
      {showHelp && (
        <Tooltip
        placement="right"
        isOpen={tooltipOpen}
        target={`helpTooltip-${id}`} // Now it correctly matches the span's id
        toggle={() => setTooltipOpen(!tooltipOpen)}
      >
        {helpText}
      </Tooltip>
      
      )}
      <div className="w-100">
        <Input
          type="file"
          id={id}
          name={name}
          onChange={handleFileChange}
          className="form-control"
          accept={acceptedTypes.length > 0 ? acceptedTypes.join(",") : ""}
          multiple={multiple} // Now supports multiple file selection
        />
        {error && <FormFeedback className="d-block">{error}</FormFeedback>}
      </div>
    </div>
  );
};

export default FileUploadInput;
